export enum GTInternalIds {
  tdm = 'gt_tdm',
  expander = 'gt_expander',
  checker = 'gt_checker',
}
